/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_AddInputs */

const cs_deal_payments_add = /** @type {(inputs: Deal_Payments_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat platbu`)
};

const en_deal_payments_add = /** @type {(inputs: Deal_Payments_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add payment`)
};

/**
* | output |
* | --- |
* | "Add payment" |
*
* @param {Deal_Payments_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_add = /** @type {((inputs?: Deal_Payments_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_add(inputs)
	return cs_deal_payments_add(inputs)
});